import apiClient from '@/api/client';
import { SimProvider } from '@/models/simProvider';

export const PartnerSimProviderService = {
    async getAll(): Promise<PartnerSimProviderResponse> {
        const response = await apiClient.get<PartnerSimProviderResponse>('/partner/sim-providers');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve sim providers.');
        }

        return result;
      },

    async create(name: string): Promise<CreatePartnerSimProviderResponse> {
        const response = await apiClient.post<CreatePartnerSimProviderResponse>('/partner/sim-providers', { 
            name
        });

        const result = response.data

        if (response.status != 201) {
            throw new Error('Failed to create sim provider.');
        }

        return result;
    },

    async delete(id: string) {
        const response = await apiClient.delete(`/partner/sim-providers/${id}`);
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to delete sim provider.');
        }

        return result;
    },
    
    async update(id: string, name: string) {
        const response = await apiClient.put(`/partner/sim-providers/${id}`, {
            name: name
        });
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to update sim provider.');
        }

        return result;
    }
}

export interface PartnerSimProviderResponse {
    simProviders: SimProvider[]
}

export interface CreatePartnerSimProviderResponse {
    simProvider: SimProvider
}